export default {
  basicInfoForm () {
    return {
      productName: '',         // 产品名称
      productHighlights: '',   // 产品亮点
      productInsideRemark: '', // 内部备注
      scenicSpotArr: [],       // 选中景点对象。addProductl中需重新处理数据，赋值 productViewIdList ，格式如: '1,2,3'
      productManageAreaIdList: '',   // 产品地区管理。格式例：'1,2,3'
      productTicketType: '',   // 票种类
      productSaleDate: []      // 这是一个时间区间数组。addProductl中需重新处理数据，赋值productSaleStartDate, productSaleEndDate
    }
  },
  contentForm () {
    return {
      scheduleDuration: '',  // 行程时长
      // productTextDescription: '', // 富文本详细文字描述
      editorProductDetail: {
        content: '',
        isChange: false,
        isOriginal: true
      },
      productViewAddress: '',  // 景点地址
      productBusinessTime: '', // 营业时间
      mealTimeArr: [],         // 用餐时段选中数组
      mealNumberType: 1,       // 用餐人数类型
      mealIntervalType: 0,     // 使用时间类型
      langArr: [],             // 服务语言选中数组
      productTraffic: '',      // 交通方式
      pathTypeArr: [],         // 路径类型  // addProduct中需重新赋值flag
      trafficArr: [],          // 交通工具  // addProduct中需重新赋值flag
      groupNumber: '',         // 成团人数
      shoppingType: 0,         // 购物类型
      // freeItem: '',         // 赠送项目
      editorFreeItem: {
        content: '',
        isChange: false,
        isOriginal: true
      },
      networkFlow4g: '',       // 4G高速网络
      networkFlow3g: '',       // 3G流量
      networkCoverage: '',     // 网络覆盖
      wifiAccessories: '',     // wifi配件
      simSize: '',             // sim卡大小
      productCostInclude: '',  // 费用包含
      productCostExclusive: '', // 费用不含
      productUseFlow: '',      // 使用流程
      imageList: [],
      videoList: [],
      newProductPackageDtoList: [],  // 套餐详情
      scheduleInfoDtoList: []   // 行程
    }
  },
  reserveSetForm () {
    return {
      // reserveLimit: {
      reserveLimitDay: '',       // 使用日期的多少天前
      reserveLimitTime: '',      // 使用日期前的多少时间
      // },
      productConfirmType: 0,    // 确认订单方式
      confirmHour: '',            // 二次确认时间
      maxReserveNummber: '',     // 最大预定数
      minReserveNummber: '',     // 最小预定数
      // ---------------------------------------------
      orderValidType: 0,     // 订单有效期类型
      delayedDay1: '',       // 有效期设置-延后天数 订单有效期类型 = 1/3设值(1设置)
      delayedDay3: '',       // 有效期设置-延后天数 订单有效期类型 = 1/3设值(3设置)
      specifiedDate2: '',     // 有效期设置-指定日期 订单有效期类型 = 2/4设值(2设置)
      specifiedDate4: '',     // 有效期设置-指定日期 订单有效期类型 = 2/4设值（4设置）
      specifiedStartDate: '', // 有效期设置-指定开始日期 订单有效期类型 = 5设值
      specifiedEndDate: '',  // 有效期设置-指定结束日期 订单有效期类型 = 5设值
      specifiedStartDay: '', // 有效期设置-指定日期开始天数 订单有效期类型 = 6设值
      specifiedEndDay: '',   // 有效期设置-指定日期结束天数 订单有效期类型 = 6设值
      // ---------------------------------------------
      // orderRefundType: 0,        // 订单退改类型
      orderRefund: {
        orderRefundType: 0,
        producttRefundDtoList: [],
        refundFee: ''
      },   // 包含退改类型（orderRefundType）和数据（producttRefundDtoList， refundFee）
      // producttRefundDtoList: [],
      // refundFee: '', // 当订单类型为2时， 使用这个退款手续费字段
      // -----------------------------------------------
      refundDescription: '',     // 退款说明
      customerDataType: 1,      // 客人资料要求类型
      // -----------------------------------------------
      mustFillInInfoArr: [],   // 选中的客人必填信息类型数组。 以此值判断：姓名填写标志 ~ 领取日期填写标志 为0 还是 1.
      // -----------------------------------------------
      productCustomCustomerItemDtoList: [{
        itemSeq: '1',      //  输入项枝番
        itemName: '',      // 输入项名称
        itemRequiredFlag: 0,  // 输入项是否能为空标志  0：可以为空、1：不能为空
        itemRange: 0,      // 输入项填写范围
        itemDescription: '' // 输入项说明
      }],

      // reserveNotice: '',      // 富文本预定需知
      editorNotice: {
        content: '',
        isChange: false,
        isOriginal: true
      },

      orderLiaisonIdList: '',  // 选中的订单联络人
      emergencyLiaisonIdList: '', // 选中的紧急联络人
      receiveCounterIdList: '', // 选中的领取柜台
      returnCounterIdList: '', // 选中的归还柜台
      validateClerkIdList: '' // 产品核销业务员
      // selOrderContactData: [],  // 选中的订单联络人数组。
      // selEmergencyContactData: [], // 选中的紧急联络人数组。
      // selPickUpCounterData: [],  // 选中的领取柜台数组。
      // selReturnCounterData: [] // 选中的归还柜台数组。
    }
  },
  addRequestForPayment () {
    return {
      productCustomCustomerItemDtoList: [{
        itemSeq: '1',      //  输入项枝番
        itemName: '',      // 输入项名称
        itemRequiredFlag: 0,  // 输入项是否能为空标志  0：可以为空、1：不能为空
        itemRange: 0,      // 输入项填写范围
        itemDescription: '' // 输入项说明
      }],
      scenicSpotArr: []  // 选中景点。赋值 productViewIdList ，格式如: '1,2,3'
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/productFormJson.js